var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionmarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13980",
    "data-name": "Group 13980",
    transform: "translate(-351 -141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15886",
    "data-name": "Path 15886",
    d: "M-2.793-2.58q-.245,0-.285-.122a1.236,1.236,0,0,1-.041-.367,17.047,17.047,0,0,1,.306-3.5A7.716,7.716,0,0,1-1.9-9,7.76,7.76,0,0,1-.409-10.772,22.794,22.794,0,0,1,1.567-12.32q.571-.408,1.223-.9a10.007,10.007,0,0,0,1.2-1.06,4.425,4.425,0,0,0,.856-1.243,3.162,3.162,0,0,0,.265-1.487,3.074,3.074,0,0,0-1.284-2.567,5.486,5.486,0,0,0-3.281-.9,10.961,10.961,0,0,0-2.893.367,17.243,17.243,0,0,0-2.2.734q-.285.122-.367.163t-.2-.245l-.489-1.63a.3.3,0,0,1,.061-.346,1.787,1.787,0,0,1,.346-.265,8.516,8.516,0,0,1,2.649-.917,15.8,15.8,0,0,1,2.975-.306,8.407,8.407,0,0,1,5.441,1.63,5.319,5.319,0,0,1,2.017,4.361,5.679,5.679,0,0,1-.734,3.1,6.431,6.431,0,0,1-1.773,1.854q-1.039.713-1.977,1.365a11.438,11.438,0,0,0-2.343,2A6,6,0,0,0-.185-6.268,12.49,12.49,0,0,0-.552-2.988a.592.592,0,0,1-.061.326A.215.215,0,0,1-.8-2.58ZM-3.4,3.492a1.411,1.411,0,0,1,.346-1.039,1.743,1.743,0,0,1,1.243-.346,1.808,1.808,0,0,1,1.3.346A1.467,1.467,0,0,1-.185,3.492a1.546,1.546,0,0,1-.326,1.06,1.738,1.738,0,0,1-1.3.367,1.677,1.677,0,0,1-1.243-.367A1.486,1.486,0,0,1-3.4,3.492Z",
    transform: "translate(374.88 175.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1476",
    "data-name": "Rectangle 1476",
    width: 50,
    height: 50,
    transform: "translate(351 141)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkIcon);
export default __webpack_public_path__ + "static/media/questionmark-icon.e989b368d214b9c4ec339ddefedcbfbd.svg";
export { ForwardRef as ReactComponent };